"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOverlayTransition = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _styledComponents = require("styled-components");

var _times = require("HubStyleTokens/times");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  .private-modal-dialog--overlay {\n    transition-property: ", ";\n    transition-delay: ", "ms;\n    transition-duration: ", "ms;\n    background-color: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var overlayTransitionTime = parseInt(_times.MODAL_BACKGROUND_TRANSITION_TIMING, 10);

var getOverlayBackgroundColor = function getOverlayBackgroundColor(hidden) {
  return "rgba(45, 62, 80, " + (hidden ? '0' : '0.79') + ")";
};

var getOverlayTransition = function getOverlayTransition(dialogTransitionTime) {
  return (0, _styledComponents.css)(_templateObject(), function (_ref) {
    var transitioning = _ref.transitioning;
    return transitioning ? 'background-color' : 'none';
  }, function (_ref2) {
    var hidden = _ref2.hidden;
    return hidden ? dialogTransitionTime : 0;
  }, overlayTransitionTime, function (_ref3) {
    var hidden = _ref3.hidden;
    return getOverlayBackgroundColor(hidden);
  });
};

exports.getOverlayTransition = getOverlayTransition;